import type { LocalizedText } from "./types";

/** Pick the right language from a LocalizedText object. Falls back to English.
 *  Handles language variants like "es-ES" → "es". */
export function lt(text: LocalizedText, lang: string): string {
  if (lang in text) return text[lang as keyof LocalizedText];
  const short = lang.split("-")[0];
  if (short in text) return text[short as keyof LocalizedText];
  return text.en;
}
